import styled, { css, DefaultTheme, StyledComponent } from 'styled-components'
import { ButtonUnstyled, Dropdown, SelectInput } from '@sketch/components'
import { ToggleWrapper } from './SearchBar.styles'

export const StyledDropdownHeader = styled(Dropdown.Header)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 20px;
  pointer-events: auto;
`

export const IconButton = styled(ButtonUnstyled)`
  cursor: pointer;
`

export const StyledSelectInput: StyledComponent<
  typeof SelectInput,
  DefaultTheme,
  {},
  never
> = styled(SelectInput)(
  ({ theme }) => css`
    border-left: 1px solid ${theme.colors.border.B};

    ${ToggleWrapper} {
      margin-left: 0;
    }
  `
)
